import { Filter } from '@ami/react/core';

export class CustomerApprovalFilter extends Filter {
  constructor(filter) {
    super(filter);
    if (filter) {
      this.search = filter.search;
      this.customerApprovalSearch = filter.customerApprovalSearch;
      this.status = filter.status;
      this.dealerBranchId = filter.dealerBranchId;
      this.dealerContactId = filter.dealerContactId;
      this.engineeringContactId = filter.engineeringContactId;
      this.engineeringTeamLeadId = filter.engineeringTeamLeadId;
      this.dealerBranchName = filter.dealerBranchName;
      this.dealerContactName = filter.dealerContactName;
      this.relatedId = filter.relatedId;
      this.engineeringStartDate = filter.engineeringStartDate;
      this.engineeringEndDate = filter.engineeringEndDate;
      this.approvalStartDate = filter.approvalStartDate;
      this.approvalEndDate = filter.approvalEndDate;
      this.isForRecentsWidget = filter.isForRecentsWidget;
      this.onlyAssignedToCurrentUser = filter.onlyAssignedToCurrentUser;
      return this;
    }
    this.search = '';
    this.customerApprovalSearch = '';
    this.status = '';
    this.dealerBranchId = '';
    this.dealerContactId = '';
    this.engineeringContactId = '';
    this.engineeringTeamLeadId = '';
    this.dealerBranchName = '';
    this.dealerContactName = '';
    this.relatedId = '';
    this.engineeringStartDate = null;
    this.engineeringEndDate = null;
    this.approvalStartDate = null;
    this.approvalEndDate = null;
    this.isForRecentsWidget = false;
    this.onlyAssignedToCurrentUser = false;
  }
}
